import { TAX_RELIEF_DEFAULT_PATH } from "./thecreditreview";

export const TAX_ASSISTANCE_PATH = "tax-assistance";

export const BTR_SITE_CONFIGURATION = {
	[TAX_ASSISTANCE_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
	[TAX_RELIEF_DEFAULT_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
};
